<ng-container [ngSwitch]="activeStep">
  <ng-container *ngSwitchCase="quickQuestionsSteps.sellingProductsToday">
    <!-- STEP 1 SellingProductsToday -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('sellingProductsToday')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.sellingProductsToday]"
        [value]="quickQuestions.sellingProductsToday"
        (valueChange)="setAnswer(quickQuestionsSteps.sellingProductsToday, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="quickQuestionsSteps.sellingProductsToday">
      </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.onlinePresence">
    <!-- STEP 2 OnlinePresence -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('onlinePresence')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.onlinePresence]"
        [value]="quickQuestions.onlinePresence"
        columnsCount="three"
        (valueChange)="setAnswer(quickQuestionsSteps.onlinePresence, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="quickQuestionsSteps.onlinePresence">
      </gd-form-field-error-message>
    </div>

    <div
      [@questionStep]="quickQuestions.onlinePresence === 'other' ? 'open' : 'closed'"
      [class]="'field other ' + activeStepConfig.containerWidth"
      [class.error]="hasError('customOnlinePresence')"
    >
      <label data-lokalise data-key="txt_custom_selling_system_field_label"></label>
      <div class="ui input fluid">
        <input
          name="customOnlinePresence"
          placeholder=""
          [ngModel]="quickQuestions.customOnlinePresence"
          (ngModelChange)="setAnswer(quickQuestionsSteps.customOnlinePresence, $event)"
        />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'customOnlinePresence'"> </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.followers">
    <!-- STEP 3 Followers -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('followers')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.followers]"
        [value]="quickQuestions.followers"
        (valueChange)="setAnswer(quickQuestionsSteps.followers, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="'followers'"> </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.isAlreadySelling">
    <!-- STEP 4 IsSelling -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('isAlreadySelling')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.isAlreadySelling]"
        [value]="quickQuestions.isAlreadySelling"
        (valueChange)="setAnswer(quickQuestionsSteps.isAlreadySelling, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="'isAlreadySelling'"> </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.ecommercePlatform">
    <!-- STEP 5 EcommercePlatform -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('ecommercePlatform')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.ecommercePlatform]"
        [multiple]="activeStepConfig.multiple"
        columnsCount="three"
        [collapse]="numberOfCollapsedElements$ | async"
        [value]="quickQuestions.ecommercePlatform"
        (valueChange)="setAnswer(quickQuestionsSteps.ecommercePlatform, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="'ecommercePlatform'"> </gd-form-field-error-message>
    </div>
    <div
      [@questionStep]="
        quickQuestions.ecommercePlatform && quickQuestions.ecommercePlatform.includes('other') ? 'open' : 'closed'
      "
      [class]="'field other ' + activeStepConfig.containerWidth"
      [class.error]="hasError('customEcommercePlatform')"
    >
      <label data-lokalise data-key="txt_custom_ecommerce_platform_field_label"></label>
      <div class="ui input fluid">
        <input
          name="customEcommercePlatform"
          placeholder=""
          [ngModel]="quickQuestions.customEcommercePlatform"
          (ngModelChange)="setAnswer(quickQuestionsSteps.customEcommercePlatform, $event)"
        />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'customEcommercePlatform'">
      </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.storeLink">
    <!-- STEP 6 storeLink  -->
    <ng-container *ngTemplateOutlet="title"></ng-container>
    <div [class]="'field answer ' + activeStepConfig.containerWidth" [class.error]="hasError('storeLink')">
      <label data-lokalise data-key="txt_link_to_your_store_label"></label>
      <div class="ui input fluid">
        <input
          name="storeLink"
          placeholder="https://example.com"
          [ngModel]="quickQuestions.storeLink"
          (ngModelChange)="setAnswer(quickQuestionsSteps.storeLink, $event)"
        />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'customReferer'"> </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.ecommerceStoreYearlyRevenue">
    <!-- STEP 7 Yearly revenue of ecommerce store -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div
      [class]="'field answers ' + activeStepConfig.containerWidth"
      [class.error]="hasError('ecommerceStoreYearlyRevenue')"
    >
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.ecommerceStoreYearlyRevenue]"
        [value]="quickQuestions.ecommerceStoreYearlyRevenue"
        (valueChange)="setAnswer(quickQuestionsSteps.ecommerceStoreYearlyRevenue, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="'ecommerceStoreYearlyRevenue'">
      </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.phoneNumber">
    <!-- STEP 8 phone-field number -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth">
      <div class="phone-fields-wrapper">
        <div class="field phone-prefix" [class.error]="hasError('phonePrefix')">
          <label data-lokalise data-key="txt_phone_number_prefix"></label>
          <ng-select
            appendTo="body"
            class="phone-codes-dropdown"
            [loading]="!countries"
            [items]="countries"
            [ngModel]="quickQuestions.phonePrefix"
            bindLabel="name"
            bindValue="dialingCode"
            [clearable]="false"
            [searchable]="true"
            [virtualScroll]="true"
            (ngModelChange)="setAnswer(quickQuestionsSteps.phonePrefix, $event)"
          >
            <ng-template ng-option-tmp let-item="item">
              <gd-country-flag [countryIsoCode]="item.code"></gd-country-flag>
              {{ item.name }} {{ item.dialingCode }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <gd-country-flag [countryIsoCode]="item.code"></gd-country-flag>
              {{ item.dialingCode }}
            </ng-template>
          </ng-select>
          <gd-form-field-error-message [error]="error" [fieldName]="'phonePrefix'"> </gd-form-field-error-message>
        </div>
        <div class="field phone-number" [class.error]="hasError('phoneNumber')">
          <label [for]="'phoneNumber'" data-lokalise data-key="txt_phone_number"></label>
          <ui-phone-field
            name="phoneNumber"
            [height]="'40'"
            [phoneNumber]="phoneNumber"
            [countryCode]="countryCode$ | async"
            (phoneChange)="setAnswer(quickQuestionsSteps.phoneNumber, $event)"
          ></ui-phone-field>
          <gd-form-field-error-message [error]="error" [fieldName]="'phoneNumber'"> </gd-form-field-error-message>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.industry">
    <!-- STEP 9 Products  -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('industry')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.industry]"
        [multiple]="activeStepConfig.multiple"
        [value]="quickQuestions.industry"
        (valueChange)="setAnswer(quickQuestionsSteps.industry, $event)"
      >
      </gd-quick-question-answer-selection-control>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.superpower">
    <!-- STEP 10 Superpower -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('superpower')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.superpower]"
        [value]="quickQuestions.superpower"
        (valueChange)="setAnswer(quickQuestionsSteps.superpower, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="quickQuestionsSteps.superpower">
      </gd-form-field-error-message>
    </div>
    <div
      [@questionStep]="quickQuestions.superpower && quickQuestions.superpower.includes('other') ? 'open' : 'closed'"
      [class]="'field other ' + activeStepConfig.containerWidth"
      [class.error]="hasError('customSuperpower')"
    >
      <label data-lokalise data-key="txt_other_field_label"></label>
      <div class="ui input fluid">
        <input
          name="customSuperpower"
          placeholder=""
          [ngModel]="quickQuestions.customSuperpower"
          (ngModelChange)="setAnswer(quickQuestionsSteps.customSuperpower, $event)"
        />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'customSuperpower'"> </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.referer">
    <!-- STEP 11 Referer  -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('referer')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.referer]"
        [value]="quickQuestions.referer"
        (valueChange)="setAnswer(quickQuestionsSteps.referer, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="'referer'"> </gd-form-field-error-message>
    </div>
    <div
      [@questionStep]="quickQuestions.referer && quickQuestions.referer.includes('other') ? 'open' : 'closed'"
      [class]="'field other ' + activeStepConfig.containerWidth"
      [class.error]="hasError('customReferer')"
    >
      <label data-lokalise data-key="txt_other_field_label"></label>
      <div class="ui input fluid">
        <input
          name="customReferer"
          placeholder=""
          [ngModel]="quickQuestions.customReferer"
          (ngModelChange)="setAnswer(quickQuestionsSteps.customReferer, $event)"
        />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'customReferer'"> </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.reviewSite">
    <!-- STEP 12 Review Site  -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('reviewSite')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.reviewSite]"
        [value]="quickQuestions.reviewSite"
        (valueChange)="setAnswer(quickQuestionsSteps.reviewSite, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="'reviewSite'"> </gd-form-field-error-message>
    </div>
    <div
      [@questionStep]="quickQuestions.reviewSite?.includes('other') ? 'open' : 'closed'"
      [class]="'field other ' + activeStepConfig.containerWidth"
      [class.error]="hasError('customReviewSite')"
    >
      <label data-lokalise data-key="txt_other_field_label"></label>
      <div class="ui input fluid">
        <input
          name="customReviewSite"
          placeholder=""
          [ngModel]="quickQuestions.customReviewSite"
          (ngModelChange)="setAnswer(quickQuestionsSteps.customReviewSite, $event)"
        />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'customReviewSite'"> </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.influencer">
    <!-- STEP 13 Influencer  -->
    <ng-container *ngTemplateOutlet="title"></ng-container>
    <div [class]="'field other ' + activeStepConfig.containerWidth" [class.error]="hasError('influencer')">
      <label data-lokalise data-key="txt_influencer_field_label"></label>
      <div class="ui input fluid">
        <textarea
          rows="2"
          name="influencer"
          placeholder=""
          [ngModel]="quickQuestions.influencer"
          (ngModelChange)="setAnswer(quickQuestionsSteps.influencer, $event)"
        ></textarea>
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="quickQuestionsSteps.influencer">
      </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.socialMediaChannel">
    <!-- STEP 14 social media channel  -->
    <ng-container *ngTemplateOutlet="title"></ng-container>

    <div [class]="'field answers ' + activeStepConfig.containerWidth" [class.error]="hasError('socialMediaChannel')">
      <gd-quick-question-answer-selection-control
        [options]="quickQuestionsOptionsCollection[quickQuestionsSteps.socialMediaChannel]"
        [value]="quickQuestions.socialMediaChannel"
        (valueChange)="setAnswer(quickQuestionsSteps.socialMediaChannel, $event)"
      >
      </gd-quick-question-answer-selection-control>
      <gd-form-field-error-message [error]="error" [fieldName]="'socialMediaChannel'"> </gd-form-field-error-message>
    </div>
    <div
      [@questionStep]="
        quickQuestions.socialMediaChannel && quickQuestions.socialMediaChannel.includes('other') ? 'open' : 'closed'
      "
      [class]="'field other ' + activeStepConfig.containerWidth"
      [class.error]="hasError('customSocialMediaChannel')"
    >
      <label data-lokalise data-key="txt_other_field_label"></label>
      <div class="ui input fluid">
        <input
          name="customSocialMediaChannel"
          placeholder=""
          [ngModel]="quickQuestions.customSocialMediaChannel"
          (ngModelChange)="setAnswer(quickQuestionsSteps.customSocialMediaChannel, $event)"
        />
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="'customSocialMediaChannel'">
      </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="quickQuestionsSteps.podcast">
    <!-- STEP 15 Podcast  -->
    <ng-container *ngTemplateOutlet="title"></ng-container>
    <div [class]="'field other ' + activeStepConfig.containerWidth" [class.error]="hasError('podcast')">
      <label data-lokalise data-key="txt_podcast_field_label"></label>
      <div class="ui input fluid">
        <textarea
          rows="2"
          name="podcast"
          placeholder=""
          [ngModel]="quickQuestions.podcast"
          (ngModelChange)="setAnswer(quickQuestionsSteps.podcast, $event)"
        ></textarea>
      </div>
      <gd-form-field-error-message [error]="error" [fieldName]="quickQuestionsSteps.podcast">
      </gd-form-field-error-message>
    </div>
  </ng-container>

  <ng-template #title>
    <h1 class="title">{{ activeStepConfig.title | translate }}</h1>
    <p class="subtitle" *ngIf="activeStepConfig.subtitle">
      {{ activeStepConfig.subtitle | translate }}
    </p>
  </ng-template>
</ng-container>
